import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/returned_checks`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/returned_checks/${id}`);
  },
  
  create(returned_check){
    return Http.post(`/returned_checks`, {returned_check: {...returned_check}})
  },

  update(returned_check){
    return Http.put(`/returned_checks/${returned_check.id}`, {
      returned_check: {...returned_check},
    });
  },


  delete(id){
    return Http.delete(`/returned_checks/${id}`)
  }

}
